/// <reference types="@lib/types" />
import isEmail from "validator/lib/isEmail";
import trim from "validator/lib/trim";
import moment from "moment-timezone";
import { FORMATS } from "../core/formats";
import { isValidScheduleDate, isValidScheduleTime } from "../schedule-field-input";
function isCloseBeforeOpen(open, close) {
    const openTime = new Date(`2000-01-01T${open}:00`);
    const closeTime = new Date(`2000-01-01T${close}:00`);
    return openTime >= closeTime;
}
const INVALID_STRING = { error: true, value: "" };
export const validators = {
    email(email) {
        if (!email)
            email = "";
        if (isEmail(email)) {
            return {
                error: false,
                value: trim(email),
            };
        }
        return INVALID_STRING;
    },
    password(value) {
        if (!value)
            value = "";
        if (value.length >= 5 && value.length <= 1024) {
            return {
                error: false,
                value: value,
            };
        }
        return INVALID_STRING;
    },
    // business_hours(hours: T.Core.Business.BusinessHours) {
    // 	for (const { open, close, h24 } of hours) {
    // 		if (!h24 && !open) {
    // 			return { error: "One of your time slots is missing an opening time. Please ensure all your hours are set" };
    // 		}
    // 		else if (!h24 && !close) {
    // 			return { error: "One of your time slots is missing a closing time. Please ensure all your hours are set" };
    // 		}
    // 		else if (!h24 && (!open.match(/^[0-2][0-9]:[0-5][0-9]$/) || !close.match(/^[0-2][0-9]:[0-5][0-9]$/))) {
    // 			return { error: "One of your time slots has an invalid opening time. Ensure your opening hours are set in 24H format between 00:00 and 23:59" };
    // 		}
    // 	}
    // 	return { error: "" };
    // },
    getTimeAsNumberOfMinutes(time) {
        const timeParts = time.split(':');
        const timeInMinutes = (Number(timeParts[0]) * 60) + Number(timeParts[1]);
        return Number(timeInMinutes);
    },
    validateTime(time) {
        const regex24Hour = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
        const regex12Hour = /^(1[0-2]|0?[1-9]):[0-5]\d\s?(AM|PM|am|pm)$/;
        return regex24Hour.test(time) || regex12Hour.test(time) || time === '24:00';
    },
    business_hours(hours) {
        if (hours) {
            for (const { open, close, h24 } of hours) {
                if (!h24 && !open) {
                    return { error: "One of your time slots is missing an opening time. Please ensure all your hours are set" };
                }
                else if (!h24 && !close) {
                    return { error: "One of your time slots is missing a closing time. Please ensure all your hours are set" };
                }
                else if (!h24 && (!this.validateTime(open) || !this.validateTime(close))) {
                    return { error: "One of your time slots has an invalid time. Ensure your hours are set in a valid format between 00:00 and 24:00" };
                }
                else if (!h24 && this.getTimeAsNumberOfMinutes(open) > this.getTimeAsNumberOfMinutes(close)) {
                    return { error: "Please ensure open time are smaller than close time" };
                }
            }
        }
        return { error: "" };
    },
    special_hours(hours) {
        if (hours) {
            for (const { open, close, h24 } of hours) {
                if (!h24 && !open) {
                    return { error: "One of your time slots is missing an opening time. Please ensure all your hours are set" };
                }
                else if (!h24 && !close) {
                    return { error: "One of your time slots is missing a closing time. Please ensure all your hours are set" };
                }
                else if (!h24 && (!this.validateTime(open) || !this.validateTime(close))) {
                    return { error: "One of your time slots has an invalid time. Ensure your hours are set in a valid format between 00:00 and 24:00" };
                }
                else if (!h24 && this.getTimeAsNumberOfMinutes(open) > this.getTimeAsNumberOfMinutes(close)) {
                    return { error: "Please ensure open time are smaller than close time" };
                }
            }
        }
        return { error: "" };
    },
    fee_specific_dates(slots) {
        if (!slots || slots.length === 0) {
            return { error: "" };
        }
        for (const slot of slots) {
            const fromDate = (slot.fromDate || "").trim();
            const toDate = (slot.toDate || slot.fromDate || "").trim();
            if (!fromDate) {
                continue;
            }
            if (!isValidScheduleDate(fromDate)) {
                return { error: "One of your date ranges has an invalid From date. Use a valid calendar date." };
            }
            if (toDate && !isValidScheduleDate(toDate)) {
                return { error: "One of your date ranges has an invalid To date. Use a valid calendar date." };
            }
            if (toDate && moment(toDate, FORMATS.moment.date, true).isBefore(moment(fromDate, FORMATS.moment.date, true), "day")) {
                return { error: "Please ensure the To date is on or after the From date." };
            }
            if (!slot.h24) {
                const open = (slot.open || "").trim();
                const close = (slot.close || "").trim();
                if (!open) {
                    return { error: "One of your date ranges is missing a Start time. Please ensure all times are set." };
                }
                if (!close) {
                    return { error: "One of your date ranges is missing an End time. Please ensure all times are set." };
                }
                if (!isValidScheduleTime(open) || !isValidScheduleTime(close)) {
                    return { error: "One of your date ranges has an invalid time. Use 24H format between 00:00 and 23:59." };
                }
                if (this.getTimeAsNumberOfMinutes(open) > this.getTimeAsNumberOfMinutes(close)) {
                    return { error: "Please ensure Start time is before End time for each date range." };
                }
            }
        }
        return { error: "" };
    },
};
export { validateWebsiteInjectHtml } from "./website-inject";
export { sanitizeReceiptRichText, validateReceiptRichText } from "./receipt-rich-text";
//# sourceMappingURL=index.js.map